import { useContext, useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { t } from 'ttag'

import ExplanationModal from '@main/containers/educators/EducatorCodeExplanationModal'
import { Text } from '@h2/components/typography/text'
import { GroupsIcon } from '@h2/components/icons/groups'
import { LessonPlanIcon } from '@h2/components/icons/lessonPlan'
import { NetworkIcon } from '@h2/components/icons/network'
import { InfoCircleIcon } from '@h2/components/icons/infoCircle'
import { EducatorsCodeIcon } from '@h2/components/icons/educatorsCode'
import { SDB } from '@h2/components/colors'

import { subNavList, navLink } from './mixins'
import { Overlay } from './overlay'

import { Context } from '../context'
import { Link as LinkComponent } from '../../link'

const Link = styled(LinkComponent)`
  ${navLink};
`
const List = styled.ul`
  ${subNavList};

  > li {
    width: 33.3%;
    border-bottom: none;

    &:last-child {
      border: none;
      width: 100%;
      position: absolute;
      top: calc(-${({ codeHeight }) => codeHeight ?? '24px'} + 1px);

      > button {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${SDB};
        padding: 0;
        margin: 0;

        > span {
          margin-right: 8px;
        }

        > span:nth-child(2) {
          margin-right: 3px;
        }

        > span:last-child {
          margin-right: 0;
        }
      }
    }
  }
`
const ManagementItems = () => {
  const { versionThreeLocalOpportunities, hasLocalOpportunities } = useContext(Context)

  return (
    <>
      <li>
        <Link href="/management/users">
          <GroupsIcon />
          <Text as="span" size={'small'}>
            {t`Users`}
          </Text>
        </Link>
      </li>
      <li>
        <Link href="/management/lessons">
          <LessonPlanIcon />
          <Text as="span" size={'small'}>
            {t`Lessons`}
          </Text>
        </Link>
      </li>
      {hasLocalOpportunities && (
        <li>
          <Link
            href={
              versionThreeLocalOpportunities
                ? '/management/localopportunities'
                : '/admin/profiles/manage'
            }>
            <NetworkIcon />
            <Text as="span" size={'small'}>
              {t`Opportunities`}
            </Text>
          </Link>
        </li>
      )}
    </>
  )
}
const ManagementMenu = () => {
  const codeRef = useRef()
  const [codeHeight, setCodeHeight] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { navHeight, userProfile } = useContext(Context)

  useEffect(() => {
    if (codeRef.current) {
      setCodeHeight(`${codeRef.current.getBoundingClientRect().height}px`)
    }
  }, [])

  return (
    <>
      <Overlay navHeight={navHeight} />
      <List offset={navHeight} codeHeight={codeHeight}>
        <ManagementItems />
        {userProfile?.management?.code && (
          <li ref={codeRef}>
            <button onClick={() => setIsModalOpen(true)}>
              <EducatorsCodeIcon />
              <Text size="small" weight="bold" color="white" as="span">
                {t`Navigator Code:`}
              </Text>
              <Text
                size="small"
                weight="bold"
                color="white"
                as="span"
                transform="uppercase">
                {userProfile.management.code}
              </Text>
              <InfoCircleIcon size="tiny" />
            </button>
          </li>
        )}
      </List>
      {isModalOpen && (
        <ExplanationModal
          show={isModalOpen}
          management={userProfile.management}
          toggleVisibility={() => setIsModalOpen(false)}
        />
      )}
    </>
  )
}

export { ManagementMenu }
